import React from "react";
import './channelList.sass';
import api from "../../utils/api";
import UserInfo from "../../components/UserInfo";
import {Button, message, Popconfirm, Table, Input,} from "antd";
import {PlusSquareOutlined, SearchOutlined} from '@ant-design/icons'
import CreateChannel from './com/createChannel'
import {Link} from "react-router-dom";
import qs from "../../utils/qs";
import {Base64} from "js-base64";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";

class ChannelList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataSource: [],
            createChannelShow: false,
            channelType: null,
            name: '',
            search: ''
        }
    }

    componentDidMount() {
        this.getChannels();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.getChannels();
        }
        return true;
    }

    getChannels = async () => {//获取渠道

        let {search} = this.state;
        let param = {}

        if (search) {
            param['search'] = search
        }
        let res = await api('get-channels', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
        console.log(res)
    }

    delChannel = async (ctx) => {//删除渠道

        let param = {
            channel_ids: ctx.id
        }


        let res = await api('del-channels', param)

        if (res.code === 200) {
            this.getChannels();
            message.success('删除成功！')
        } else {
            message.error(res.message)
        }
    }


    editorChannel = (ctx) => {//编辑渠道
        this.setState({
            createChannelShow: true,
            channelType: ctx
        })
    }

    searchRule = async () => {
        let {name} = this.state;
        let sqlarr = [
            {name: 'name', val: name, rule: "like"}
        ]
        let sql = qs.sqlSearch(sqlarr);
        let {search} = sql;
        search = Base64.encode(JSON.stringify(search));
        await this.setState({
            search
        })
        let hide = message.loading('搜索中')
        this.getChannels();
        hide();
    }

    render() {

        let {dataSource, createChannelShow, channelType} = this.state

        const columns = [
            {
                title: '渠道名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '备注',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex'>

                            <Link className='pointer mgr10 themeColor'
                                  to={'/user/channelMembers?id=' + ctx.id}>查看</Link>

                            <p onClick={() => {
                                this.editorChannel(ctx)
                            }} className='pointer mgr10 themeColor'>编辑</p>

                            <Popconfirm
                                title='确认删除？'
                                okText='确认'
                                cancelText='取消'
                                onConfirm={() => {

                                    this.delChannel(ctx)

                                }}
                            >
                                <p className='warn pointer'>删除</p>
                            </Popconfirm>


                        </div>
                    )
                }
            },
        ];
        return (
            <div className='channelList'>

                <UserInfo rightBox={
                    <ul className='flex census'>
                        <li>
                            <label>全部成员</label>
                            <p>0</p>
                        </li>
                    </ul>
                }/>

                <div className='record'>

                    <div className='change_fans flex search'>
                        <div className='flex'>
                            <div className='flex line alignCenter'>
                                搜索昵称：
                                <Input placeholder='搜索昵称：' onChange={(e) => {
                                    this.setState({name: e.target.value})
                                }}/>
                            </div>
                            <div>
                                <Button onClick={() => {
                                    this.searchRule()
                                }} icon={<SearchOutlined/>}>搜索</Button>

                                <Button>重置</Button>
                            </div>

                        </div>
                    </div>

                    <div className='change_fans'>
                        <Button onClick={() => {
                            this.setState({createChannelShow: true, channelType: null})
                        }} icon={<PlusSquareOutlined/>} className='createChannelBtn themeBtn mgb10'>新建渠道</Button>
                        <Table dataSource={dataSource} columns={columns}/>
                    </div>
                </div>

                {
                    createChannelShow ? <CreateChannel channelType={channelType} update={(e) => {
                        this.getChannels()
                    }} colsePop={(e) => {
                        this.setState({createChannelShow: !e})
                    }}/> : null
                }
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(ChannelList);